import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '@/views/Login.vue';

// Management
import matriz from './modules/management/matriz';
import rates from './modules/management/rates';
import accordance from './modules/management/accordance';
import promoters from './modules/management/promoters';
import promoterInvoices from './modules/management/promoterInvoices';
import users from './modules/management/users';
import corban from './modules/management/corban';
import hub from './modules/management/hub';

// Services
import fgts from './modules/services/fgts';
import workerCredit from './modules/services/workerCredit';
import creditCard from './modules/services/creditCard';
import inss from './modules/services/inss';
import livelo from './modules/services/livelo';
import cgv from './modules/services/cgv';
import comunicacoes from './modules/services/comunicacoes';

import { shouldChangePassword } from './middlewares/passwordValidation';
import { requireSession, alreadySignedIn, landingPath } from './middlewares/requireSession';
import { readOnlyRedirect } from './middlewares/readOnlySession';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    ...matriz,
    ...rates,
    ...accordance,
    ...promoters,
    ...promoterInvoices,
    ...users,
    ...corban,
    ...fgts,
    ...workerCredit,
    ...creditCard,
    ...inss,
    ...livelo,
    ...cgv,
    ...comunicacoes,
    ...hub,
    { path: '*', component: Login },
  ],
});

router.beforeEach((to, from, next) => {
  if (!requireSession(to)) return next({ name: 'login' });

  const landing = landingPath();
  if (alreadySignedIn(to) && landing && to.path !== landing) return next({ path: landing });

  const consultOnly = readOnlyRedirect(to, (path) => router.resolve(path).route.path);
  if (consultOnly) return next({ path: consultOnly });

  return shouldChangePassword(to, from, next);
});

export default router;
